import { CartLinesUpdateEvent } from '@shopify/events';

class FandomCompleteLook extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const signal = this.controller.signal;
    this.querySelectorAll('.fd-look__form').forEach((form) => {
      const select = form.querySelector('select[name="id"]');
      if (select) form.querySelector('button[type="submit"]').disabled = !select.value;
    });
    this.addEventListener('change', (event) => {
      const select = event.target.closest('select[name="id"]');
      if (!select) return;
      const card = select.closest('[data-look-card]');
      card.querySelector('button[type="submit"]').disabled = !select.value;
      const price = select.selectedOptions[0]?.dataset.price;
      if (price) card.querySelector('[data-look-price]').textContent = price;
    }, { signal });
    this.addEventListener('submit', (event) => this.addItem(event), { signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  async addItem(event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.fd-look__form')) return;
    event.preventDefault();
    if (this.busy || !form.reportValidity()) return;
    const data = new FormData(form);
    const variant = data.get('id');
    if (!variant) return;
    this.busy = true;
    const button = form.querySelector('button[type="submit"]');
    const status = this.querySelector('[role="status"]');
    const buttons = [...this.querySelectorAll('button[type="submit"]')];
    const disabledBefore = buttons.map((item) => item.disabled);
    buttons.forEach((item) => { item.disabled = true; });
    status.textContent = this.dataset.adding;
    form.setAttribute('aria-busy', 'true');
    const sectionIds = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map((item) => item.dataset.sectionId))].slice(0, 5);
    if (sectionIds.length) data.set('sections', sectionIds.join(','));
    data.set('sections_url', window.location.pathname);
    const update = CartLinesUpdateEvent.createPromise();
    this.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: String(variant), quantity: 1 }], promise: update.promise }));
    let added = false;
    try {
      const response = await fetch(this.dataset.addUrl + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: data });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
      added = true;
      status.textContent = this.dataset.added;
      const cartResponse = await fetch(this.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) throw new Error('Cart refresh failed');
      const cart = await cartResponse.json();
      update.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, sections: result.sections, source: 'fandom-complete-look', sourceId: this.dataset.parent, itemCount: 1, didError: false } });
    } catch (error) {
      update.reject(error);
      status.textContent = added ? this.dataset.added : (error.message || this.dataset.error);
    } finally {
      buttons.forEach((item, index) => { item.disabled = disabledBefore[index]; });
      form.removeAttribute('aria-busy');
      this.busy = false;
      button.focus({ preventScroll: true });
    }
  }
}

if (!customElements.get('fandom-complete-look')) customElements.define('fandom-complete-look', FandomCompleteLook);
